import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Body } from '@swyftx/aviary/atoms/Typography';
import { BodyProps } from '@swyftx/aviary/atoms/Typography/Body/Body.styles';

import { observer } from 'mobx-react-lite';
import { useMarginPositionDetails } from 'src/lib/margin/hooks/positions';

type Props = {
  positionId?: string;
  dynamicColors?: boolean;
  weight?: BodyProps['weight'];
  size?: BodyProps['size'];
  color?: BodyProps['color'];
};

const MarginSide: React.FC<Props> = observer(
  ({ positionId, dynamicColors = true, weight = 'none', size = 'medium', color }) => {
    const { t } = useTranslation('margin');
    const { side, isLong } = useMarginPositionDetails({ positionId });

    const bodyColor = useMemo((): BodyProps['color'] => {
      if (color) return color;
      if (!dynamicColors) return 'primary';

      if (isLong) return 'success';

      return 'error';
    }, [color, dynamicColors, isLong]);

    if (!positionId || side === undefined) return null;

    return (
      <Body size={size} color={bodyColor} className='whitespace-nowrap' weight={weight}>
        {t(`tradeSide.${side}`)}
      </Body>
    );
  },
);

export { MarginSide };
